module.exports = __webpack_public_path__ + "img/6.3fcf6bab.png";